import { CookieManager } from "./cookie-manager.types";

const removeSubdomains = (url: URL) => {
  const urlParts = url.hostname.split(".");

  return urlParts
    .slice(0)
    .slice(-(urlParts[urlParts.length - 1].match(/br/gm) ? 3 : 2))
    .join(".");
};

export const cookieManager: CookieManager = {
  get: ({ cookieName }) => {
    const value = document.cookie
      ?.split("; ")
      .find((row) => row.startsWith(`${cookieName}=`))
      ?.split("=")
      .slice(1)
      .join("=");
    return value as any;
  },

  set: ({
    cookieName,
    value,
    expirationDate,
    globally = false,
    path = "/",
  }) => {
    let cookie = `${cookieName}=${value}; path=${path};`;

    if (expirationDate) {
      const dateUTCString = expirationDate.toUTCString();
      cookie += ` expires=${dateUTCString};`;
    }

    if (globally) {
      const domain = removeSubdomains(new URL(window.location.href));
      cookie += ` domain=${domain};`;
    }

    document.cookie = cookie;
  },

  remove: ({ cookieName, globally = false, path = "/" }) => {
    const date = new Date();
    date.setFullYear(2000);

    let cookie = `${cookieName}=; expires=${date.toUTCString()}; path=${path};`;

    if (globally) {
      const domain = removeSubdomains(new URL(window.location.href));
      cookie += ` domain=${domain};`;
    }

    document.cookie = cookie;
  },
};
